import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { user, isLoggedIn, logout } = useAuth();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    logout();
    setDropdownOpen(false);
    navigate('/');
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getUserDisplayName = () => {
    if (user?.firstName && user?.lastName) {
      return user.firstName + " " + user.lastName;
    }
    if (user?.firstName) {
      return user.firstName;
    }
    if (user?.email) {
      return user.email.split('@')[0];
    }
    return 'User';
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src="/logo.png" alt="Tali Restaurants" className="navbar-logo" />
        </Link>

        {isLoggedIn && user?.id ? (
          <div className="user-dropdown" ref={dropdownRef}>
            <button
              className="user-dropdown-btn"
              onClick={toggleDropdown}
              aria-expanded={dropdownOpen}
            >
              <i className="bi bi-person-circle"></i>
              <span className="user-name">{getUserDisplayName()}</span>
              <i className={dropdownOpen ? "bi bi-chevron-up dropdown-arrow" : "bi bi-chevron-down dropdown-arrow"}></i>
            </button>

            {dropdownOpen && (
              <div className="user-dropdown-menu">
                <Link
                  className="dropdown-item"
                  to="/"
                  onClick={() => setDropdownOpen(false)}
                >
                  <i className="bi bi-house-fill"></i>
                  Home
                </Link>
                <Link
                  className="dropdown-item"
                  to="/my-reservations"
                  onClick={() => setDropdownOpen(false)}
                >
                  <i className="bi bi-calendar-check-fill"></i>
                  My Reservations
                </Link>
                <Link
                  className="dropdown-item"
                  to="/my-profile"
                  onClick={() => setDropdownOpen(false)}
                >
                  <i className="bi bi-person-fill"></i>
                  My Profile
                </Link>
                <div className="dropdown-divider"></div>
                <button
                  className="dropdown-item logout-item"
                  onClick={handleLogout}
                >
                  <i className="bi bi-box-arrow-right"></i>
                  Logout
                </button>
              </div>
            )}
          </div>
        ) : (
          <>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <Link className="nav-link" to="/">
                    <i className="bi bi-house-fill me-1"></i>
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/login">
                    <i className="bi bi-box-arrow-in-right me-1"></i>
                    Login
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/register">
                    <i className="bi bi-person-plus-fill me-1"></i>
                    Register
                  </Link>
                </li>
              </ul>
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
